import AuthPage from '@src/components/Molecules/Auth/AuthPage';
import AuthContainer from '@src/components/Organism/Auth/AuthContainer';
import React from 'react';

const AuthTemplate = () => {
  return (
    <>
      <AuthContainer padding="100px 0px" paddingBottom="50px">
        <AuthPage />
      </AuthContainer>
    </>
  );
};

export default AuthTemplate;
